import { ColumnProps } from 'antd/lib/table';
import { ConsultaMensual } from './Responses';

export const ConsultaMensualTable: Array<ColumnProps<ConsultaMensual>> = [
    {
        title: 'Concepto',
        dataIndex: 'tipo',
        key: 'tipo',
    },
    {    
        title: 'Sin Captura',
        dataIndex: 'totalNuevo',
        key: 'totalNuevo',
    },
    {    
        title: 'Guardado',
        dataIndex: 'totalGuardado',
        key: 'totalGuardado',
    },
    {    
        title: 'Capturado',
        dataIndex: 'totalCapturado',
        key: 'totalCapturado',
    },
    {    
        title: 'Rechazado',
        dataIndex: 'totalRechazado',
        key: 'totalRechazado',
    },
    {    
        title: 'Corregido',
        dataIndex: 'totalCorregido',
        key: 'totalCorregido',
    },
    
    {    
        title: 'Aprobado',
        dataIndex: 'totalAprobado',
        key: 'totalAprobado',
    },

    {    
        title: 'Total',
        dataIndex: 'total',
        key: 'total',
    },
];